export enum ContactListSortBy {
    None = 0,
    NameAsc = 1,
    NameDesc = 2,
    CompanyAsc = 3,
    CompanyDesc = 4,
    EmailAsc = 5,
    EmailDesc = 6,
    PhoneAsc = 7,
    PhoneDesc = 8,
    NumAsc = 9,
    NumDesc = 10,
}